<div class="content">
  <ppl-option-list-categories *ngIf="showCategoriesSidebar"
                              [categories]="normalizedSearchCategories"
                              [value]="selectedCategory"
                              (valueChange)="onSelectedCategoryChange($event)"
                              [class.default-width]="listWidth === undefined"
                              [style.max-height.px]="maxContainerHeight ? maxContainerHeight : null"
                              [style.min-height.px]="showCategoriesSidebar ? (maxContainerHeight || 200) : null"
                              [style.width.px]="categoriesSidebarWidth"></ppl-option-list-categories>

  <div #container
       class="container"
       [class.with-search]="showCategoriesSidebar"
       [style.max-height.px]="maxContainerHeight ? maxContainerHeight : null"
       [style.min-height.px]="showCategoriesSidebar ? (maxContainerHeight || 200) : null"
       [style.width.px]="listWidth">

    <ng-container *ngIf="actionsTemplate">
      <ng-container *ngTemplateOutlet="actionsTemplate"></ng-container>
    </ng-container>

    <ppl-virtual-scroll *ngIf="!!normalizedOptions.length"
                        #virtualScroll
                        [data]="normalizedOptions"
                        [dataTemplate]="rowTemplate"
                        [minRowHeight]="25"
                        [rowHeights]="rowHeights"
                        [recordsContent]="recordsContent"
                        (scrollChange)="onScrollChange($event)">
    </ppl-virtual-scroll>

    <div *ngIf="(displayNoResults && !displayLoading) || (displayAllCategories && !displayLoading && normalizedOptions.length === 0)"
         class="no-results"
         [style.height.px]="optionTemplateRowHeight || 25">{{ intl.noResultsFound }}</div>

    <ng-template #recordsContent
                 let-scrollTop="scrollTop">
      <div *ngFor="let option of normalizedOptionsCategoriesOnly; trackBy: trackById"
           class="category"
           [style.top.px]="Math.max(option.offsetTop, scrollTop)">
        <div class="category-label">{{option.value ? option.value.label : ''}}</div>
      </div>
    </ng-template>

    <ng-template #rowTemplate
                 let-option
                 let-style="style">
      <div class="row"
           [ngStyle]="style">
        <div *ngIf="option.kind === NormalizedOptionKind.Item"
             class="item"
             [class.selected]="(option.value.value === value)"
             [attr.data-index]="option.index"
             (click)="onOptionClick(option.value, $event)"
             (mouseenter)="onOptionMouseEnter(option.value.value)">
          <ng-container *ngIf="optionTemplate; else basicOption">
            <ng-container *ngTemplateOutlet="optionTemplate; context: { '\$implicit': option.value }"></ng-container>
          </ng-container>
          <ng-template #basicOption>
            <div class="item-basic">
              <ppl-icon *ngIf="option.value.icon"
                        class="item-icon"
                        [svgIcon]="option.value.icon"
                        width="14px"
                        height="14px"></ppl-icon>

              <div class="item-label"
                   [style.color]="option.value.color || null"
                   [attr.title]="option.value.labelInList || option.value.label || null">
                {{option.value.labelInList || option.value.label}}
              </div>
            </div>
          </ng-template>
        </div>

        <ppl-loading-overlay *ngIf="option.kind === NormalizedOptionKind.Loading"></ppl-loading-overlay>
      </div>
    </ng-template>
  </div>
</div>

<div class="footer">
  <div *ngIf="displayCreate"
       class="create"
       (click)="onOptionCreate()">
    <ppl-icon svgIcon="color-add"
              width="18px"
              height="18px"></ppl-icon>
    <div class="create-label">{{displayCreateOption}} <span class="create-label-token">"{{createValue}}"</span></div>
  </div>
  <div *ngIf="footerTemplate && !!options?.length"
       class="footer-template">
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </div>
</div>
